module.exports = __webpack_public_path__ + "img/sdtps-logo.59756924.png";